export default "__VITE_ASSET__1b0ad7a7__"